import Decimal from 'decimal.js'
import { getChargeRecordsPrint } from '@/api/charge/charge'
import { custFormatDate } from './data-jsFn'
import { DICT_TYPE, getDictLabel } from './dict'

type RefundPaymentRecord = { payChannelCode: string; price: string | number; createTime: string; remark?: string }
const escapeHtml = (value: unknown) => String(value ?? '')
  .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;').replace(/'/g, '&#039;')

export async function getRefundPaymentRecords(medicalRecordId: string | number): Promise<RefundPaymentRecord[]> {
  const res = await getChargeRecordsPrint({ medicalRecordId, type: 2, pageSize: -1 })
  if (res.code !== 0 || !Array.isArray(res.data)) throw new Error(res.msg || '获取退费流水失败')
  return res.data
}

export function renderChargeRefundReceipt(patient: any, config: any, records: RefundPaymentRecord[], printedAt = new Date()) {
  const fontSize = Math.max(Number(config.fontSize) || 12, 12)
  const row = (label: string, value: unknown) => value == null || value === '' ? '' : `<div>${label}：${escapeHtml(value)}</div>`
  const payments = new Map<string, Decimal>()
  records.forEach(record => payments.set(record.payChannelCode, (payments.get(record.payChannelCode) ?? new Decimal(0)).plus(record.price)))
  const paymentText = [...payments].map(([code, amount]) => {
    const label = getDictLabel(DICT_TYPE.CLINIC_PAY_CHANNEL, code)
    if (!label) throw new Error(`支付方式字典缺少配置：${code}`)
    return `${label}-${amount.toFixed(2)}`
  }).join('，')
  const latestRecord = records.reduce<RefundPaymentRecord | undefined>((latest, record) =>
    !latest || new Date(record.createTime).getTime() > new Date(latest.createTime).getTime() ? record : latest, undefined)
  const age = [patient.ageYear != null ? `${patient.ageYear}岁` : '', patient.ageMonth ? `${patient.ageMonth}月` : '', patient.ageDay ? `${patient.ageDay}天` : ''].filter(Boolean).join(' ')
  const sex = patient.sex === 1 ? '男' : patient.sex === 2 ? '女' : ''
  const phone = config.phoneDisplay === 3 ? '' : config.phoneDisplay === 1
    ? patient.mobile : String(patient.mobile ?? '').replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
  return `<div style="font-size:${fontSize}px;line-height:${fontSize + 2}px;font-family:Arial,'Microsoft YaHei',sans-serif;">
    <div style="text-align:center;">
      ${config.settingName ? `<div style="font-size:${fontSize + 2}px;font-weight:bold;">${escapeHtml(config.settingName)}</div>` : ''}
      ${patient.clinicAddress ? `<div style="font-size:${Math.max(fontSize - 1, 10)}px;">${escapeHtml(patient.clinicAddress)}</div>` : ''}
      ${patient.contactPhone ? `<div>${escapeHtml(patient.contactPhone)}</div>` : ''}
      <div style="font-size:${fontSize + 2}px;margin:3px 0;">退费单</div>
    </div>
    ${row('姓名', [patient.userName, sex, age].filter(Boolean).join(' '))}
    ${row('手机', phone)}${row('诊号', patient.medicalSection)}${row('医生', patient.doctorName)}
    <div style="border-top:1px dashed #000;border-bottom:1px dashed #000;padding:3px 0;margin:3px 0;">${row('实退', paymentText)}</div>
    ${latestRecord?.createTime ? row('退费时间', custFormatDate(latestRecord.createTime, 'YYYY-MM-DD HH:mm:ss')) : ''}
    ${row('打印时间', custFormatDate(printedAt, 'YYYY-MM-DD HH:mm:ss'))}
    ${row('收款备注', patient.remark || '无')}
    ${config.announcement ? `<div>${escapeHtml(config.announcement)}</div>` : ''}
    ${config.footerContent?.includes('退换提醒') ? '<div style="text-align:center;margin-top:3px;">药品离柜，概不退换</div>' : ''}
  </div>`
}
